export const onboardingSteps = {
  WELCOME: 'welcome',
  ESTABLISHMENT: 'establishment',
  PRICE_TABLE: 'priceTable',
  SERVICE_TABLE: 'serviceTable',
  USER: 'user',
  TICKET: 'ticket',
  CASHIER: 'cashier',
  PAYMENT_METHODS: 'paymentMethods',
  DASHBOARD: 'dashboard'
}

export const jumpParkOnboarding = {
  welcome: 'https://www.youtube.com/embed/yAd6sSoMI8U?autoplay=1&mute=1&enablejsapi=1',
  establishment: 'https://youtube.com/embed/PLexqbZbFIE?autoplay=1&mute=1&enablejsapi=1',
  priceTable: 'https://youtube.com/embed/WDmd3oKmd6w?autoplay=1&mute=1&enablejsapi=1',
  serviceTable: 'https://youtube.com/embed/eEdBf4bpfN8?autoplay=1&mute=1&enablejsapi=1',
  user: 'https://youtube.com/embed/_8ht_vz54-Y?autoplay=1&mute=1&enablejsapi=1',
  ticket: 'https://www.youtube.com/embed/cx3BQ-P_m4U?autoplay=1&mute=1&enablejsapi=1',
  cashier: 'https://youtube.com/embed/xrExOulxQlE?autoplay=1&mute=1&enablejsapi=1',
  paymentMethods: 'https://youtube.com/embed/-X1n6SDFZbI?autoplay=1&mute=1&enablejsapi=1',
  dashboard: 'https://www.youtube.com/embed/D27qjumgNA8?autoplay=1&mute=1&enablejsapi=1'
}

export const jumpCarOnboarding = {
  welcome: 'https://www.youtube.com/embed/PpLKgQVTlS0?autoplay=1&mute=1&enablejsapi=1',
  establishment: 'https://www.youtube.com/embed/Omgog5fQRQY?autoplay=1&mute=1&enablejsapi=1',
  priceTable: 'https://youtube.com/embed/WDmd3oKmd6w?autoplay=1&mute=1&enablejsapi=1',
  serviceTable: 'https://youtube.com/embed/eEdBf4bpfN8?autoplay=1&mute=1&enablejsapi=1',
  user: 'https://www.youtube.com/embed/8M2mR9zuHcg?autoplay=1&mute=1&enablejsapi=1',
  ticket: 'https://www.youtube.com/embed/-zO0ItnJV2Y?autoplay=1&mute=1&enablejsapi=1',
  cashier: 'https://www.youtube.com/embed/9msXBW9wBPs?autoplay=1&mute=1&enablejsapi=1',
  paymentMethods: 'https://youtube.com/embed/W3veTsF-mXw?autoplay=1&mute=1&enablejsapi=1',
  dashboard: 'https://www.youtube.com/embed/XMs_VXfFok0?autoplay=1&mute=1&enablejsapi=1'
}